import { gtmSendEvent } from "@wojo/analytics";
import { useI18n } from "@wojo/localization";
import { StoryblokImage } from "@wojo/storyblok";
import { Text, VideoPlayer } from "@wojo/ui";
import React from "react";
import { TourAssetUnion } from "../../../generated/graphql";
import styles from "./EquipmentModalMedia.module.scss";

type EquipmentModalMediaProps = {
    mediaAssets?: TourAssetUnion[];
};

export const EquipmentModalMedia = React.forwardRef<
    HTMLDivElement,
    EquipmentModalMediaProps
>(({ mediaAssets }, ref) => {
    const { productPage } = useI18n("productPage");

    return (
        <section
            ref={ref}
            className={styles.media}
            aria-label={productPage.equipment.accessibleMediaLabel.l()}
        >
            {mediaAssets?.map((mediaAsset, index) => {
                if (mediaAsset.__typename === "TourImage") {
                    return (
                        <figure
                            className={styles["override-figure"]}
                            key={`${mediaAsset.image}-${index}`}
                        >
                            {mediaAsset.image && (
                                <StoryblokImage
                                    style={{
                                        width: "100%",
                                        height: "auto",
                                    }}
                                    loading="eager"
                                    mobile={{
                                        asset: mediaAsset.image,
                                        size: {
                                            width: 327,
                                        },
                                    }}
                                    desktop={{
                                        asset: mediaAsset.image,
                                        size: {
                                            width: 565,
                                        },
                                    }}
                                />
                            )}
                            {mediaAsset.caption && (
                                <Text.Body
                                    order="2"
                                    variant="2"
                                    className={styles.caption}
                                    tag="figcaption"
                                >
                                    {mediaAsset.caption}
                                </Text.Body>
                            )}
                        </figure>
                    );
                } else if (mediaAsset.__typename === "TourVideo") {
                    return (
                        <figure
                            className={styles["override-figure"]}
                            key={`${mediaAsset.wistiaVideoId}-${index}`}
                        >
                            <VideoPlayer
                                videoId={mediaAsset.wistiaVideoId ?? ""}
                                requestAutoplay={false}
                                loopVideo={false}
                                playerColor="#191919"
                                style={{
                                    height: "100%",
                                    width: "100%",
                                }}
                                preserveAspectRatio
                                onPlaybackChange={(videoState) => {
                                    gtmSendEvent({
                                        event: "track",
                                        ga4Tracking: {
                                            ga4_object: "EQUIPMENT_MODAL_VIDEO",
                                            ga4_action:
                                                videoState.toUpperCase(),
                                            videoId:
                                                mediaAsset.wistiaVideoId ?? "",
                                        },
                                    });
                                }}
                            />
                            {mediaAsset.caption && (
                                <Text.Body
                                    order="2"
                                    variant="2"
                                    className={styles.caption}
                                    tag="figcaption"
                                >
                                    {mediaAsset.caption}
                                </Text.Body>
                            )}
                        </figure>
                    );
                }
            })}
        </section>
    );
});

EquipmentModalMedia.displayName = "EquipmentModalMedia";
